<div class="blog-details-page">
  @if (loading) {
    <section class="blog-loading animate-fade-in-up">
      Loading article...
    </section>
  }

  @if (post) {
    <article class="blog-details-wrap animate-fade-in-up" aria-label="Blog Post">
      <div class="blog-details-layout">
        <div class="blog-details-top">
          <button class="blog-back" type="button" (click)="backToBlog()">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Knowledge Base Return
          </button>
          <div class="blog-meta">
            <span class="blog-meta__category">{{ post.category }}</span>
            <span class="blog-meta__item">{{ post.date }}</span>
            <span class="blog-meta__dot">&bull;</span>
            <span class="blog-meta__item">{{ post.readTime }}</span>
          </div>
          <h1 class="blog-title">{{ post.title }}</h1>
          <div class="blog-author">
            @if (post.authorImageUrl) {
              <img class="blog-author__avatar" [src]="post.authorImageUrl"
                [alt]="post.authorImageAlt" loading="lazy">
            }
            @if (!post.authorImageUrl) {
              <div class="blog-author__icon">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
              </div>
            }
            <div>
              <div class="blog-author__label">Author</div>
              <div class="blog-author__name">{{ post.author }}</div>
            </div>
            <div class="blog-preferred-source">
              <div google-add-preferred-source-btn data-theme="light"></div>
            </div>
          </div>
        </div>
        <figure class="blog-cover">
          <img [src]="post.imageUrl" [alt]="post.imageAlt" loading="lazy">
        </figure>
        <div class="blog-content">
          <p class="blog-excerpt">{{ post.excerpt }}</p>
          <section class="blog-richtext" [innerHTML]="renderedBody" aria-label="Article body"></section>
        </div>
        <div class="blog-engage">
          <div>
            <div class="blog-engage__title">Ready to transform your operations?</div>
            <div class="blog-engage__copy">Connect with our architects to deploy this framework.</div>
          </div>
          <button class="blog-engage__btn" type="button" (click)="openCalendlyPopup()">Engage Reve</button>
        </div>
      </div>
    </article>
  } @else {
    <section class="blog-empty">
      <div class="blog-empty__title">404</div>
      <div class="blog-empty__copy">{{ errorMessage || 'This article is currently unavailable.' }}</div>
      <button class="blog-empty__btn" type="button" (click)="backToBlog()">Return to Blog</button>
    </section>
  }


  <!-- <section id="contact" class="contact-section" aria-label="Contact Us">
  <div class="contact-section__container">
    <div class="contact-section__grid">
      <div>
        <div class="contact-section__eyebrow">Connect</div>
        <div class="contact-section__title">Discover the future of applied AI.</div>
        <div class="contact-section__copy">
          Connect with our delivery experts to audit your topology and map your enterprise integration
          roadmap.
        </div>
      </div>

      <div class="contact-card">
        <div class="contact-card__corner" aria-hidden="true"></div>
        <div class="contact-card__title">Direct Inquiry</div>

        <div *ngIf="submitted" role="alert" class="contact-card__success animate-fade-in-up">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          <div>Request securely logged. Our architecture team will reach out within one business day.
          </div>
        </div>

        <form *ngIf="!submitted" [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
          <div class="contact-form__field">
            <input type="text" formControlName="name" placeholder="Full Name" />
          </div>

          <div class="contact-form__row">
            <div class="contact-form__field">
              <input type="email" formControlName="email" placeholder="Corporate Email" />
            </div>
            <div class="contact-form__field">
              <input type="text" formControlName="company" placeholder="Organization" />
            </div>
          </div>

          <div class="contact-form__field">
            <textarea rows="3" formControlName="message"
            placeholder="Brief context of operational challenges..."></textarea>
          </div>

          <button type="submit" [disabled]="contactForm.invalid || isSubmitting"
            class="contact-form__submit">
            <span *ngIf="!isSubmitting">Transmit Request</span>
            <span *ngIf="isSubmitting" class="contact-form__submit-loading">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
              Encrypting...
            </span>
          </button>
        </form>
      </div>
    </div>
  </div>
</section> -->
</div>
